import { Box, ButtonNew, IconNew, TextNew } from '@jfs/ui-new'
import * as React from 'react'
import { FC } from 'react'
import { Modal, ModalTypes } from '../../comps/ModalWeb'
import { Separator } from '../Separator'
import { shadowStyle, styles } from './styles'
import { AlertProps } from './types'

export enum AlertTypes {
  Default = 'Default',
  Error = 'Error',
  Confirm = 'Confirm',
}

const renderAlertModal = (
  type: AlertTypes,
  title: string,
  subTitle: string,
  onPress: () => void,
  confirmOkLabel: string,
  confirmCancelLabel: string,
  onSecondaryPress: () => void,
): React.ReactElement => {
  const BTN_LABEL = confirmOkLabel ?? 'Ok'
  const isConfirmCancelBtn = type === AlertTypes.Confirm && confirmCancelLabel
  return (
    <Box {...styles[type].container}>
      <TextNew {...styles[type].title}>{title}</TextNew>
      <Box marginHorizontal={8} marginVertical={16} flexDirection={'row'}>
        {isConfirmCancelBtn && subTitle.length > 0 && (
          <Box marginRight={8}>
            <IconNew id="BILL" size={16} color="BLACK_21" />
          </Box>
        )}
        <TextNew {...styles[type].subTitle}>{subTitle}</TextNew>
      </Box>
      {isConfirmCancelBtn && <Separator height={1} width={'100%'} border={'SEPERATOR'} />}
      <Box {...styles[type].buttonContainer}>
        {isConfirmCancelBtn && onSecondaryPress && (
          <Box marginRight={16}>
            <ButtonNew
              title={confirmCancelLabel}
              onPress={isConfirmCancelBtn ? onPress : onSecondaryPress}
              testID="alertBtn1"
              type="secondarySmall"
              {...shadowStyle}
              borderColor="GREY_SEPARATOR"
              borderRadius={4}
            />
          </Box>
        )}
        <ButtonNew
          titleColor={'WHITE'}
          color={isConfirmCancelBtn ? 'ERROR' : 'PRIMARY'}
          onPress={isConfirmCancelBtn ? onSecondaryPress : onPress}
          testID="alertBtn2"
          type={'secondarySmall'}
          title={BTN_LABEL}
          {...shadowStyle}
          borderColor="GREY_SEPARATOR"
          borderRadius={4}
          hoverColor={isConfirmCancelBtn ? 'ERROR' : 'BG_PRIMARY_BUTTON_HOVER'}
        />
      </Box>
    </Box>
  )
}
const Alert: FC<AlertProps> = ({
  title,
  subTitle,
  onPress,
  type = AlertTypes.Default,
  visible = false,
  confirmOkLabel = 'Ok',
  confirmCancelLabel,
  onAction,
}: AlertProps) => {
  return (
    <Modal
      view={renderAlertModal(type, title || '', subTitle, onPress, confirmOkLabel, confirmCancelLabel, onAction)}
      visible={visible}
      onPress={onPress}
      type={type !== AlertTypes.Confirm ? ModalTypes.Alert : ModalTypes.CONFIRM_ALERT}
    />
  )
}

export default Alert
